export const APP_BANNER_EXTENDED_TYPES = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
}
